import axiosInstance from "app/axiosInstance";
import { types } from "@vilocnv/allsetra-core";
import { DriverMileageSearchResponseDto } from "../entities/dtos/driver-mileage.dto";

export const getDriverMileageByQuery = async (
  accountId: string,
  params: types.IRecordsAggregationBody
): Promise<DriverMileageSearchResponseDto> => {
  try {
    const response = await axiosInstance.post(
      `/accounts/${accountId}/drivers-private-mileage/search`,
      params
    );

    return response.data;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
